import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { Tags } from 'components/Settings/Components/Tags/components/tags';

export const TagsPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.tags.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader title={settingsConfig.tags.title} subTitle={'Add & edit Tags'} />
            </HeaderWrapper>
            <MainContent>
                <Tags />
            </MainContent>
        </PageContainer>
    );
};
